import React from "react"
import { withRadium, DetectCompact } from "higher-order-components"
import { Heading, VideoBackground } from "components"
import { Content } from 'AtomicComponents'
import { LayeredBackgroundImageAutoplay, Column, ColumnGroup } from "containers"
import componentParser from "AtomicUtils/componentParser"
// /**
//  * Render a full width image section
//  * @param {'compact'|'medium'|'tall','extra tall', 'widescreen'} [height=compact] - Module height.
//  * @param {'full width'|'article'} [width=article] - Width mode of module.
//  * @param {String} backgroundImage - url for background image.
//  * @param {Url} [backgroundVideo] - Video Url. If not defined hero will show only background image.
//  * @param {'left'|'right'|'center'} [textAlign=center] - Text alignment of content.
//  * @param {'left'|'right'|'center'} [align=center] - Alignment of text block.
//  * @param {String} [heading] - text heading.
//  * @param {String} [preHeading] - text pre heading.
//  * @param {String} [blurb] - text blurb (accepts html).
//  * @param {'light'|'dark'} [wysiwygTheme='light'] - colour theme name for wysiwyg.
//  * @param {'top'|'bottom'|'center'} [textVerticalAlign=center] - Vertical text alignment.
//  * @returns {ReactElement} React Component
//  */

export function FullWidthImageSectionContainer({
  height,
  width,
  backgroundImage,
  mobileBackgroundImage,
  compact = false,
  backgroundImageArray,
  backgroundVideo,
  textAlign,
  interval,
  loop,
  align,
  fullWidth,
  floating = false,
  heading,
  headingSize,
  mobileHeading = heading,
  blurb,
  tagOverride,
  wysiwygTheme,
  textVerticalAlign,
  children,
  components = []
}) {

  let length = 0
  if (components && components.length && components.length > 0) {
    length = components.length
  }else if (children && children.length && children.length > 0 ) {
    length = children.length
  }

  let orientation
  return (
    <section style={[{ display: "flex", width: "100%" }, width === "article" && styles.articleColumn]}>
      <div
        style={{
          textAlign: "center",
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          color: "white",
          display: "flex",
          position: "relative",
          width: "100%",
          overflow: "hidden",
          zIndex: 0,
          backgroundSize: "cover",
          backgroundImage: floating && length ? "" : `url(${mobileBackgroundImage || backgroundImage})`,
          "@media (min-width: 768px)": {
            backgroundImage: floating && length ? "" : `url(${backgroundImage})`
          }
        }}>
        {floating && length ? (
          <div
            style={{
              backgroundImage: `url(${mobileBackgroundImage || backgroundImage})`,
              "@media (min-width: 768px)": {
                backgroundImage: `url(${backgroundImage})`
              },
              backgroundPosition: "center top",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              position: "absolute",
              zIndex: -1,
              height: "65%",
              width: "100%"
            }} />
        ) : null}
        <ColumnGroup>
          <Column textAlign={textAlign}>
            <div
              style={[
                styles.base(fullWidth && length),
                styles[align],
                !(floating && length) && styles.height(height)
              ]}>
              <div>{compact}</div>
              <div
                style={[
                  { display: fullWidth && length ? "block" : "table-cell" },
                  styles.verticalAlign(textVerticalAlign)
                ]}>
                <div>
                  <div>
                    <Heading
                      white
                      tag={tagOverride || "h2"}
                      size={headingSize}
                      value={compact ? mobileHeading : heading} />
                    {blurb && <Content xmlString={blurb} theme={wysiwygTheme} />}
                    <div style={{
                      display: "flex",
                      justifyContent: textAlign === "center" ? "center": "none",
                      flexDirection: "column",
                      alignItems: "center",
                      position: "relative"
                    }}>
                      {componentParser(components) || children}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Column>
        </ColumnGroup>
        {backgroundVideo && <VideoBackground orientation={orientation} src={backgroundVideo} />}
        {backgroundImageArray &&
          backgroundImageArray.length > 1 && (
            <LayeredBackgroundImageAutoplay
              interval={interval}
              loop={loop}
              imageSrcArray={backgroundImageArray}
              backgroundSize="cover" />
          )}
      </div>
    </section>
  )
}

FullWidthImageSectionContainer.defaultProps = {
  align: "center",
  textAlign: "center",
  height: "compact",
  width: "full width",
  wysiwygTheme: "light"
}

export default withRadium(DetectCompact())(FullWidthImageSectionContainer)

const styles = {
  base: fullWidth => ({
    maxWidth: fullWidth ? "none" : "calc(40em + 4vw)",
    boxSizing: "border-box",
    padding: "4vw 0",
    display: fullWidth ? "block" : "table",
    height: fullWidth ? "auto" : 0
  }),
  verticalAlign: alignment => ({
    verticalAlign: alignment === "center" ? "middle" : alignment
  }),
  height: height => {
    switch (height) {
    case "widescreen":
      return {
        minHeight: "180vw",
        "@media (min-width: 768px)": {
          minHeight: "56vw"
        }
      }
    case "extra tall":
      return {
        minHeight: "150vw",
        "@media (min-width: 768px)": {
          minHeight: "50vw"
        }
      }
    case "tall":
      return {
        minHeight: "100vw",
        "@media (min-width: 768px)": {
          minHeight: "40vw"
        }
      }
    case "medium":
      return {
        minHeight: "80vw",
        "@media (min-width: 768px)": {
          minHeight: "30vw"
        }
      }
    case "fit":
      return {}
    default:
      return {
        minHeight: "50vw",
        "@media (min-width: 768px)": {
          minHeight: "20vw"
        }
      }
    }
  },
  articleColumn: {
    maxWidth: "60em",
    margin: "auto",
    overflow: "auto"
  },
  left: {
    marginRight: "auto"
  },
  right: {
    marginLeft: "auto"
  },
  center: {
    margin: "0 auto"
  }
}



// WEBPACK FOOTER //
// ./src/components/full-width-image-section/index.jsx